import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, vModelSelect as _vModelSelect, withModifiers as _withModifiers, vModelCheckbox as _vModelCheckbox, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-44a39730"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "card-global hr-page" }
const _hoisted_2 = { class: "hr-heading" }
const _hoisted_3 = { class: "page-title" }
const _hoisted_4 = { class: "hr-actions" }
const _hoisted_5 = ["onSubmit"]
const _hoisted_6 = { value: "" }
const _hoisted_7 = ["value"]
const _hoisted_8 = { value: "" }
const _hoisted_9 = { value: "ACTIVE" }
const _hoisted_10 = { value: "DISMISSED" }
const _hoisted_11 = { value: "ARCHIVED" }
const _hoisted_12 = { value: "SERVICE" }
const _hoisted_13 = {
  key: 0,
  class: "hr-error"
}
const _hoisted_14 = {
  key: 1,
  class: "hr-bulk-actions"
}
const _hoisted_15 = { key: 0 }
const _hoisted_16 = {
  key: 2,
  role: "status"
}
const _hoisted_17 = ["aria-label"]
const _hoisted_18 = { class: "hr-table" }
const _hoisted_19 = { key: 0 }
const _hoisted_20 = ["checked", "indeterminate", "disabled", "aria-label", "title"]
const _hoisted_21 = { class: "hr-actions-heading" }
const _hoisted_22 = { key: 0 }
const _hoisted_23 = ["colspan"]
const _hoisted_24 = { key: 1 }
const _hoisted_25 = ["colspan"]
const _hoisted_26 = { key: 0 }
const _hoisted_27 = ["value", "disabled", "aria-label"]
const _hoisted_28 = { class: "hr-employee-cell" }
const _hoisted_29 = { key: 0 }
const _hoisted_30 = { class: "hr-job-cell" }
const _hoisted_31 = ["title"]
const _hoisted_32 = {
  key: 0,
  class: "hr-muted"
}
const _hoisted_33 = {
  key: 1,
  class: "hr-progress"
}
const _hoisted_34 = { class: "hr-row-actions" }
const _hoisted_35 = { class: "hr-row-actions__content" }

import {
  computed,
  onBeforeUnmount,
  onMounted,
  reactive,
  ref,
  watch,
} from "vue";
import { useRoute } from "vue-router";
import { useStore } from "vuex";
import { Button } from "@/components/common";
import TablePagination from "@/components/common/pagination/TablePagination.vue";
import HrDataService from "@/services/hr/HrDataService";
import HrNotificationModal from "@/components/hr/HrNotificationModal.vue";
import HrEmployeeStatusBadge from "@/components/hr/HrEmployeeStatusBadge.vue";
import { HrEmployeeSummary, HrReferenceData } from "@/types/hr/Hr";
import { AuthGetters } from "@/store/modules/auth";
import { t } from "@/i18n";
import { accountKey } from "@/utils/accountSession";


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

/* Legacy ESLint does not detect template usage from script setup. */
/* eslint-disable @typescript-eslint/no-unused-vars */
const store = useStore();
const route = useRoute();
const employmentTypeCode = computed(() =>
  route.query.employmentType === "GPH" ? "GPH" : "CONTRACT"
);
const employeeTypes = ref<{ id: string; code: string }[]>([]);
const referencesReady = ref(false);
const employees = ref<HrEmployeeSummary[]>([]);
const reference = ref<HrReferenceData>({ companies: [], jobs: [], users: [] });
const loading = ref(false);
const error = ref("");
const selectedEmployees = ref<string[]>([]);
const selectingAll = ref(false);
const matchingEmployeeIds = ref<string[]>([]);
const notificationOpen = ref(false);
const notificationMode = ref<"REQUEST" | "EXPIRY">("REQUEST");
const notificationSuccess = ref(false);
let selectionSequence = 0;
const selectedEmployeeSet = computed(() => new Set(selectedEmployees.value));
const allSelected = computed(
  () =>
    matchingEmployeeIds.value.length > 0 &&
    matchingEmployeeIds.value.every((id) => selectedEmployeeSet.value.has(id))
);
function resetSelection() {
  selectionSequence++;
  selectingAll.value = false;
  selectedEmployees.value = [];
  matchingEmployeeIds.value = [];
  notificationOpen.value = false;
}
function employeeFilterParams() {
  return {
    query: filters.query || undefined,
    jobId: filters.jobId || undefined,
    status: filters.status || undefined,
    employeeTypeId: employeeTypes.value.find(
      (item) => item.code === employmentTypeCode.value
    )?.id,
  };
}
async function selectAllEmployees() {
  if (
    loading.value ||
    selectingAll.value ||
    !canEdit.value ||
    !filtersApplied.value
  )
    return;
  if (allSelected.value) {
    resetSelection();
    return;
  }
  const params = employeeFilterParams();
  if (!params.employeeTypeId) return;
  const sequence = ++selectionSequence;
  selectingAll.value = true;
  error.value = "";
  try {
    const response = await HrDataService.getEmployeeSelection(params);
    if (sequence !== selectionSequence) return;
    matchingEmployeeIds.value = response.data.data;
    selectedEmployees.value = [...matchingEmployeeIds.value];
  } catch {
    if (sequence === selectionSequence) error.value = t("hr.loadError");
  } finally {
    if (sequence === selectionSequence) selectingAll.value = false;
  }
}
function openNotifications(mode: "REQUEST" | "EXPIRY") {
  if (
    !canEdit.value ||
    loading.value ||
    selectingAll.value ||
    !filtersApplied.value ||
    !selectedEmployees.value.length
  )
    return;
  notificationMode.value = mode;
  notificationSuccess.value = false;
  notificationOpen.value = true;
}
async function notificationsSaved() {
  notificationSuccess.value = true;
  resetSelection();
  await load(pager.currentPage);
}
const filters = reactive({ query: "", jobId: "", status: "" });
const appliedFilterKey = ref("");
const filtersApplied = computed(
  () => JSON.stringify(employeeFilterParams()) === appliedFilterKey.value
);
let loadSequence = 0;
let searchTimer: ReturnType<typeof setTimeout> | undefined;
function cancelSearch() { if (searchTimer !== undefined) clearTimeout(searchTimer); searchTimer = undefined; }
function searchNow() { cancelSearch(); if (referencesReady.value) void load(1); }
const pager = reactive({
  currentPage: 1,
  totalPages: 0,
  startPage: 1,
  endPage: 1,
});
const permissions = computed<string[]>(
  () => store.getters[AuthGetters.GET_USER_IDENTITY]?.permissions || []
);
const canEdit = computed(() => permissions.value.includes("HR_EMPLOYEE_EDIT"));
const canManageSettings = computed(() =>
  permissions.value.includes("HR_SETTINGS_MANAGE")
);

async function load(page = 1) {
  cancelSearch();
  const params = employeeFilterParams();
  const filterKey = JSON.stringify(params);
  if (appliedFilterKey.value && filterKey !== appliedFilterKey.value) page = 1;
  const sequence = ++loadSequence;
  loading.value = true;
  error.value = "";
  try {
    const employeeType = employeeTypes.value.find(
      (item) => item.code === employmentTypeCode.value
    );
    if (!employeeType) {
      employees.value = [];
      Object.assign(pager, {
        currentPage: 1,
        totalPages: 0,
        startPage: 1,
        endPage: 0,
      });
      error.value = t("hr.employeeTypeUnavailable");
      return;
    }
    const response = await HrDataService.getEmployees({ page, ...params });
    if (sequence !== loadSequence) return;
    employees.value = response.data.data.items;
    appliedFilterKey.value = filterKey;
    Object.assign(pager, response.data.data.pager);
  } catch {
    if (sequence !== loadSequence) return;
    error.value = t("hr.loadError");
  } finally {
    if (sequence === loadSequence) loading.value = false;
  }
}

function maskIin(iin: string) {
  return iin.length === 12 ? `${iin.slice(0, 4)}••••${iin.slice(-4)}` : iin;
}

function apiErrorMessage(exception: unknown, fallback: string) {
  const response = exception as { response?: { data?: { message?: string } } };
  return response.response?.data?.message || fallback;
}

watch(filters, () => {
  resetSelection();
  cancelSearch();
  loadSequence++;
  if (referencesReady.value) searchTimer = setTimeout(searchNow, 300);
}, { flush: "sync" });
watch(
  canEdit,
  (allowed) => {
    if (!allowed) resetSelection();
  },
  { flush: "sync" }
);
watch(
  () => accountKey(store.getters[AuthGetters.GET_USER_IDENTITY]),
  () => {
    cancelSearch();
    resetSelection();
    loadSequence++;
    employees.value = [];
    employeeTypes.value = [];
    referencesReady.value = false;
    referenceSequence++;
    appliedFilterKey.value = "";
    reference.value = { companies: [], jobs: [], users: [] };
    loading.value = false;
    if (permissions.value.includes("HR_VIEW")) void initializeReferences();
  },
  { flush: "sync" }
);
watch(employmentTypeCode, () => {
  cancelSearch();
  resetSelection();
  if (!referencesReady.value) return;
  employees.value = [];
  Object.assign(pager, { currentPage: 1, totalPages: 0, startPage: 1, endPage: 0 });
  load(1);
});

let referenceSequence = 0;
async function initializeReferences() {
  const sequence = ++referenceSequence;
  try {
    const [response, typesResponse] = await Promise.all([
      HrDataService.getReferenceData(),
      HrDataService.getEmployeeTypes(),
    ]);
    if (sequence !== referenceSequence) return;
    reference.value = response.data.data;
    employeeTypes.value = typesResponse.data.data;
  } catch {
    if (sequence !== referenceSequence) return;
    reference.value = { companies: [], jobs: [], users: [] };
    error.value = t("hr.loadError");
    return;
  }
  referencesReady.value = true;
  await load();
}
onMounted(initializeReferences);
onBeforeUnmount(() => {
  cancelSearch();
  loadSequence++;
  selectionSequence++;
  referenceSequence++;
});

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", null, [
        _createElementVNode("h1", _hoisted_3, _toDisplayString(_unref(employmentTypeCode) === 'GPH' ? 'Сотрудники по ГПХ' : 'Сотрудники по ТД'), 1),
        _createElementVNode("p", null, _toDisplayString(_unref(t)("hr.employeesHint")), 1)
      ]),
      _createElementVNode("div", _hoisted_4, [
        _createVNode(_component_router_link, { to: { name: 'HrAnalytics' } }, {
          default: _withCtx(() => [
            _createVNode(_unref(Button), { variant: "default" }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_unref(t)("hr.analytics")), 1)
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        (_unref(canManageSettings))
          ? (_openBlock(), _createBlock(_component_router_link, {
              key: 0,
              to: { name: 'HrSettings' }
            }, {
              default: _withCtx(() => [
                _createVNode(_unref(Button), { variant: "default" }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_unref(t)("hr.settings")), 1)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }))
          : _createCommentVNode("", true),
        _createVNode(_component_router_link, { to: { name: 'HrAudit' } }, {
          default: _withCtx(() => [
            _createVNode(_unref(Button), { variant: "default" }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_unref(t)("hr.audit.title")), 1)
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        (_unref(canEdit))
          ? (_openBlock(), _createBlock(_component_router_link, {
              key: 1,
              to: { name: 'HrEmployeeCreate' }
            }, {
              default: _withCtx(() => [
                _createVNode(_unref(Button), null, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_unref(t)("hr.addEmployee")), 1)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }))
          : _createCommentVNode("", true)
      ])
    ]),
    _createElementVNode("form", {
      class: "hr-filters",
      onSubmit: _withModifiers(searchNow, ["prevent"])
    }, [
      _createElementVNode("label", null, [
        _createElementVNode("span", null, _toDisplayString(_unref(t)("hr.searchEmployee")), 1),
        _withDirectives(_createElementVNode("input", {
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(filters).query) = $event)),
          class: "input-form",
          type: "search"
        }, null, 512), [
          [
            _vModelText,
            _unref(filters).query,
            void 0,
            { trim: true }
          ]
        ])
      ]),
      _createElementVNode("label", null, [
        _createElementVNode("span", null, _toDisplayString(_unref(t)("common.job")), 1),
        _withDirectives(_createElementVNode("select", {
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_unref(filters).jobId) = $event)),
          class: "input-form"
        }, [
          _createElementVNode("option", _hoisted_6, _toDisplayString(_unref(t)("hr.all")), 1),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(reference.value.jobs, (item) => {
            return (_openBlock(), _createElementBlock("option", {
              key: item.id,
              value: item.id
            }, _toDisplayString(item.name), 9, _hoisted_7))
          }), 128))
        ], 512), [
          [_vModelSelect, _unref(filters).jobId]
        ])
      ]),
      _createElementVNode("label", null, [
        _createElementVNode("span", null, _toDisplayString(_unref(t)("common.status")), 1),
        _withDirectives(_createElementVNode("select", {
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_unref(filters).status) = $event)),
          class: "input-form"
        }, [
          _createElementVNode("option", _hoisted_8, _toDisplayString(_unref(t)("hr.all")), 1),
          _createElementVNode("option", _hoisted_9, _toDisplayString(_unref(t)("hr.statusActive")), 1),
          _createElementVNode("option", _hoisted_10, _toDisplayString(_unref(t)("hr.statusDismissed")), 1),
          _createElementVNode("option", _hoisted_11, _toDisplayString(_unref(t)("hr.statusArchived")), 1),
          _createElementVNode("option", _hoisted_12, _toDisplayString(_unref(t)("hr.statusService")), 1)
        ], 512), [
          [_vModelSelect, _unref(filters).status]
        ])
      ])
    ], 40, _hoisted_5),
    (error.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_13, _toDisplayString(error.value), 1))
      : _createCommentVNode("", true),
    (_unref(canEdit))
      ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
          _createElementVNode("span", null, _toDisplayString(_unref(t)("hr.selectedEmployees")) + ": " + _toDisplayString(selectedEmployees.value.length), 1),
          (_unref(allSelected))
            ? (_openBlock(), _createElementBlock("span", _hoisted_15, _toDisplayString(_unref(t)("hr.allMatchingSelected")), 1))
            : _createCommentVNode("", true),
          _createVNode(_unref(Button), {
            type: "button",
            disabled: !selectedEmployees.value.length || loading.value || selectingAll.value,
            onClick: _cache[3] || (_cache[3] = ($event: any) => (openNotifications('REQUEST')))
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_unref(t)("hr.requestDocuments")), 1)
            ]),
            _: 1
          }, 8, ["disabled"]),
          _createVNode(_unref(Button), {
            type: "button",
            disabled: !selectedEmployees.value.length || loading.value || selectingAll.value,
            onClick: _cache[4] || (_cache[4] = ($event: any) => (openNotifications('EXPIRY')))
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_unref(t)("hr.enableExpiry")), 1)
            ]),
            _: 1
          }, 8, ["disabled"])
        ]))
      : _createCommentVNode("", true),
    (notificationSuccess.value)
      ? (_openBlock(), _createElementBlock("p", _hoisted_16, _toDisplayString(_unref(t)("hr.notificationActionSaved")), 1))
      : _createCommentVNode("", true),
    _createElementVNode("div", {
      class: "hr-table-wrap",
      tabindex: "0",
      role: "region",
      "aria-label": _unref(t)('hr.employees')
    }, [
      _createElementVNode("table", _hoisted_18, [
        _createElementVNode("thead", null, [
          _createElementVNode("tr", null, [
            (_unref(canEdit))
              ? (_openBlock(), _createElementBlock("th", _hoisted_19, [
                  _createElementVNode("input", {
                    type: "checkbox",
                    checked: _unref(allSelected),
                    indeterminate: selectedEmployees.value.length > 0 && !_unref(allSelected),
                    disabled: 
                  loading.value ||
                  selectingAll.value ||
                  !_unref(filtersApplied) ||
                  !employees.value.length ||
                  Boolean(_unref(filters).status && _unref(filters).status !== 'ACTIVE')
                ,
                    "aria-label": _unref(t)('hr.selectAllEmployees'),
                    title: _unref(t)('hr.selectAllEmployees'),
                    onChange: selectAllEmployees
                  }, null, 40, _hoisted_20)
                ]))
              : _createCommentVNode("", true),
            _createElementVNode("th", null, _toDisplayString(_unref(t)("common.fullName")), 1),
            _createElementVNode("th", null, _toDisplayString(_unref(t)("common.job")), 1),
            _createElementVNode("th", null, _toDisplayString(_unref(t)("hr.completeness")), 1),
            _createElementVNode("th", null, _toDisplayString(_unref(t)("hr.missing")), 1),
            _createElementVNode("th", null, _toDisplayString(_unref(t)("common.status")), 1),
            _createElementVNode("th", _hoisted_21, _toDisplayString(_unref(t)("hr.actions")), 1)
          ])
        ]),
        _createElementVNode("tbody", null, [
          (loading.value)
            ? (_openBlock(), _createElementBlock("tr", _hoisted_22, [
                _createElementVNode("td", {
                  colspan: _unref(canEdit) ? 7 : 6
                }, _toDisplayString(_unref(t)("hr.loading")), 9, _hoisted_23)
              ]))
            : (!employees.value.length)
              ? (_openBlock(), _createElementBlock("tr", _hoisted_24, [
                  _createElementVNode("td", {
                    colspan: _unref(canEdit) ? 7 : 6
                  }, _toDisplayString(_unref(t)("common.noData")), 9, _hoisted_25)
                ]))
              : _createCommentVNode("", true),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(employees.value, (employee) => {
            return (_openBlock(), _createElementBlock("tr", {
              key: employee.id
            }, [
              (_unref(canEdit))
                ? (_openBlock(), _createElementBlock("td", _hoisted_26, [
                    _withDirectives(_createElementVNode("input", {
                      "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((selectedEmployees).value = $event)),
                      type: "checkbox",
                      value: employee.id,
                      disabled: 
                  employee.status !== 'ACTIVE' ||
                  loading.value ||
                  selectingAll.value ||
                  !_unref(filtersApplied)
                ,
                      "aria-label": employee.fullName
                    }, null, 8, _hoisted_27), [
                      [_vModelCheckbox, selectedEmployees.value]
                    ])
                  ]))
                : _createCommentVNode("", true),
              _createElementVNode("td", _hoisted_28, [
                _createVNode(_component_router_link, {
                  to: { name: 'HrEmployeeDetails', params: { id: employee.id } }
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("strong", null, _toDisplayString(employee.fullName), 1)
                  ]),
                  _: 2
                }, 1032, ["to"]),
                (employee.iin)
                  ? (_openBlock(), _createElementBlock("small", _hoisted_29, _toDisplayString(maskIin(employee.iin)), 1))
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("td", _hoisted_30, [
                _createElementVNode("span", {
                  title: employee.jobName || ''
                }, _toDisplayString(employee.jobName || "—"), 9, _hoisted_31)
              ]),
              _createElementVNode("td", null, [
                (employee.requiredDocumentCount === 0)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_32, _toDisplayString(_unref(t)("hr.notConfigured")), 1))
                  : (_openBlock(), _createElementBlock("div", _hoisted_33, [
                      _createElementVNode("div", null, [
                        _createElementVNode("span", {
                          style: _normalizeStyle({ width: `${employee.completionPercentage}%` })
                        }, null, 4)
                      ]),
                      _createElementVNode("strong", null, _toDisplayString(employee.completionPercentage) + "%", 1)
                    ]))
              ]),
              _createElementVNode("td", null, _toDisplayString(employee.missingRequiredDocumentCount), 1),
              _createElementVNode("td", null, [
                _createVNode(HrEmployeeStatusBadge, {
                  status: employee.status
                }, null, 8, ["status"])
              ]),
              _createElementVNode("td", _hoisted_34, [
                _createElementVNode("div", _hoisted_35, [
                  _createVNode(_component_router_link, {
                    class: "btn btn-soft-primary",
                    to: {
                    name: 'HrEmployeeDetails',
                    params: { id: employee.id },
                  }
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_unref(t)("common.details")), 1)
                    ]),
                    _: 2
                  }, 1032, ["to"])
                ])
              ])
            ]))
          }), 128))
        ])
      ])
    ], 8, _hoisted_17),
    _createVNode(HrNotificationModal, {
      show: notificationOpen.value,
      "employee-ids": selectedEmployees.value,
      mode: notificationMode.value,
      onClose: _cache[6] || (_cache[6] = ($event: any) => (notificationOpen.value = false)),
      onSent: notificationsSaved
    }, null, 8, ["show", "employee-ids", "mode"]),
    (_unref(pager).totalPages > 1)
      ? (_openBlock(), _createBlock(TablePagination, {
          key: 3,
          current: _unref(pager).currentPage,
          "onUpdate:current": _cache[7] || (_cache[7] = ($event: any) => ((_unref(pager).currentPage) = $event)),
          "total-pages": _unref(pager).totalPages,
          "onUpdate:total-pages": _cache[8] || (_cache[8] = ($event: any) => ((_unref(pager).totalPages) = $event)),
          "start-page": _unref(pager).startPage,
          "end-page": _unref(pager).endPage,
          onPageChanged: load
        }, null, 8, ["current", "total-pages", "start-page", "end-page"]))
      : _createCommentVNode("", true)
  ]))
}
}

})